import EventBookingContainer from './EventBookingContainer';

export default EventBookingContainer;
